import _findKey from 'lodash/findKey';
import _toLower from 'lodash/toLower';
import { ThemeSingleton } from "../theme/index.js";
import { COLOR_VARIANTS } from "../theme/palette.theme/index.js";
import { TYPOGRAPHY_VARIANT } from "../theme/typography.theme/index.js";
export var color = function color(colorName) {
  var colorType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'main';
  var theme = ThemeSingleton.getInstance('ltr');
  return theme.palette[colorName] ? theme.palette[colorName][colorType] : theme.palette[COLOR_VARIANTS.AQUA100][colorType];
};
export var colorName = function colorName(colorCode) {
  var theme = ThemeSingleton.getInstance('ltr');
  return _findKey(theme.palette, function (color) {
    return _toLower(color.main) === _toLower(colorCode);
  });
};
export var fontFamily = function fontFamily() {
  var theme = ThemeSingleton.getInstance('ltr');
  return theme.typography.fontFamily;
};
export var typography = function typography(variant) {
  var theme = ThemeSingleton.getInstance('ltr');
  return theme.typography[variant] || theme.typography[TYPOGRAPHY_VARIANT.BODY2];
};
export var typographyStyle = function typographyStyle(variant) {
  var theme = ThemeSingleton.getInstance('ltr');
  var typography = theme.typography[variant] || theme.typography[TYPOGRAPHY_VARIANT.BODY2];
  return "\n    font-size: ".concat(typography.fontSize, ";\n    line-height: ").concat(typography.lineHeight, ";\n    font-weight: ").concat(typography.fontWeight, ";\n  ");
};
export var isSaudiSymbol = function isSaudiSymbol(currency) {
  return ['SAR', 'ر.س.', 'ر.س.‏'].includes(currency);
};